var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('CommonHeader'),_c('router-view'),_c('Contact'),_c('CommonFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }